export default __webpack_public_path__ + "static/media/AlignMiddle.5df9e75f.svg";